import React from "react"

const Contracts = () => {
  return (
    <section className="container mx-auto pt-20 px-6">
      <h2>ACUERDO MAESTRO DE SERVICIOS</h2>
      <p className="pb-20">Actualizado: 6 de julio de 2020</p>
      <p className="pb-4">
        POR CUANTO, Avalith (Tres cubos S.A) se dedica a la contratación de
        profesionales de tecnología especializados que brindan servicios de
        ingeniería, conocidos como “Ingenieros”; y
      </p>
      <p className="pb-4">
        CONSIDERANDO QUE, Partner (junto con Avalith, las "Partes") desea
        involucrar a Avalith con el personal Engineers for Partner.
      </p>
      <p className="pb-4">
        AHORA ENTONCES, por y en consideración de las mutuas promesas y pactos
        aquí contenidos, las Partes acuerdan lo siguiente:
      </p>
      <h4 className="pb-4 font-bold text-xl">1. SERVICIOS</h4>
      <p className="pb-4">
        Avalith acepta dotar de personal a sus Ingenieros para socios (los
        "Servicios") como se describe en una o más Declaraciones de trabajo
        ("SOW") en el formulario adjunto como Anexo A del Formulario de pedido
        entre las Partes. Cualquier conflicto o incoherencia entre las
        disposiciones de este Acuerdo y cualquier SOW o Formulario de pedido
        ejecutado se resolverá a favor del Formulario de pedido, SOW y Acuerdo,
        en ese orden.
      </p>
      <h4 className="pb-4 font-bold text-xl">2. TÉRMINOS Y TERMINACIÓN</h4>
      <p className="pb-4">
        (a) Continuación. Este Acuerdo permanecerá en vigor y regirá los
        Servicios proporcionados al Socio por Avalith hasta que este Acuerdo sea
        rescindido o las Partes acuerden lo contrario (el "Término de MSA").
        Cada SOW comenzará en la fecha de inicio correspondiente del Ingeniero y
        continuará durante el "Término inicial" establecido en el mismo. Después
        del Período Inicial, cada SOW se renovará automáticamente por períodos
        adicionales de un mes hasta que cualquiera de las Partes rescinda dicha
        SOW de acuerdo con los términos del presente.
      </p>
      <p className="pb-4">
        (b) Terminación por conveniencia. Cualquiera de las Partes podrá
        rescindir este Acuerdo mediante notificación por escrito con 90 días de
        antelación a la otra Parte. Cada SOW puede ser rescindida, en su
        totalidad o en parte, por cualquiera de las Partes mediante notificación
        por escrito con 90 días de anticipación a la otra Parte.
      </p>
      <p className="pb-4">(c) Terminación por Causa.</p>

      <p className="pb-4 pl-12">
        (i) Incumplimiento material. Con la excepción de los incumplimientos
        monetarios como se describe en la Sección 2 (c) (ii), cualquiera de las
        partes puede rescindir este Acuerdo o cualquier SOW si la otra parte
        incumple cualquier disposición material de este Acuerdo o de un SOW. La
        parte que no incumple debe notificar por escrito con 14 días de
        calendario (describiendo la infracción en detalle) y la oportunidad de
        subsanar la infracción.
      </p>

      <p className="pb-4 pl-12">
        (ii) Incumplimiento Monetario. Avalith puede rescindir este Acuerdo o
        cualquier SOW si el Socio no realiza un pago monetario dentro de los 30
        días posteriores a la recepción de la factura. Avalith notificará por
        escrito al Socio con 14 días de calendario (describiendo los montos
        adeudados) y la oportunidad de subsanar el incumplimiento.
      </p>

      <p className="pb-4 pl-12">
        (iii) Efecto de la rescisión. Tras la rescisión de este Acuerdo por
        cualquier motivo, el Socio pagará inmediatamente a Avalith todos los
        montos adeudados a Avalith de conformidad con la Sección 3 del presente
        por los Servicios prestados antes de la fecha de vigencia de la
        rescisión, incluido cualquier reembolso de gastos según la Sección 3
        (c). En el caso de rescisión por incumplimiento del Socio, el Socio
        también será responsable de los costos razonables de Avalith
        relacionados con el cumplimiento de las obligaciones del Socio, incluido
        el cobro de los cargos impagos adeudados y pagaderos en virtud de este
        Acuerdo. Para evitar dudas, la terminación de este Acuerdo no afectará
        los derechos y / u obligaciones de las Partes que surgieron antes de
        dicha terminación, incluidas, entre otras, las garantías,
        indemnizaciones, limitaciones de responsabilidad,
      </p>

      <h4 className="pb-4 font-bold text-xl">
        3. HONORARIOS DE SERVICIOS PROFESIONALES, CONSIDERACIÓN, PAGO
      </h4>

      <p className="pb-4">
        (a) Tarifas. El Socio pagará a Avalith las tarifas (las "Tarifas")
        establecidas en el SOW correspondiente. El Socio debe pagar y pagar
        todas las Tarifas mensualmente dentro de los 30 días posteriores a la
        recepción de una factura por dichas Tarifas. El Socio notificará a
        Avalith sobre cualquier Tarifa en disputa dentro de los 30 días
        posteriores a la recepción de dicha factura. Las facturas se emitirán
        antes del día 5 de cada mes en el que se realizarán los Servicios. Los
        pagos atrasados ​​devengan intereses a una tasa menor del 1.5% por mes o
        la tasa legal más alta aplicable.
      </p>

      <p className="pb-4">
        (b) Contacto de facturación. Cada Parte designará, de vez en cuando, un
        único punto de contacto que tendrá la responsabilidad principal en
        nombre de la Parte designante de revisar, responder y resolver cualquier
        consulta relacionada con la facturación o el pago que pueda surgir
        durante el curso de este Acuerdo.
      </p>

      <p className="pb-4">
        (c) Gastos. Avalith tiene derecho a un reembolso por parte del Socio por
        los gastos de viaje y de desembolso personal documentados en los que se
        haya incurrido razonablemente y que sean necesarios para la prestación
        de los Servicios por parte de Avalith. A menos que se especifique lo
        contrario en el SOW aplicable, el Socio debe aprobar previamente por
        escrito todos los gastos de reembolso. Avalith respaldará todas las
        solicitudes de reembolso de gastos de viaje con documentación que
        incluya recibos de gastos.
      </p>

      <p className="pb-4">
        (d) Elevación. En cada aniversario del Período inicial, las Tarifas en
        el SOW aplicable aumentarán en un 10%. Avalith notificará al Socio con
        90 días de anticipación sobre dicho aumento.
      </p>

      <h4 className="pb-4 font-bold text-xl">4. PERSONAL, PERSONAL</h4>

      <p className="pb-4">
        Avalith buscará, contratará, contratará y seleccionará a su personal de
        acuerdo con el SOW aplicable, y Avalith tendrá la exclusiva discreción
        sobre el personal utilizado para proporcionar los Servicios, siempre que
        Avalith se asegure de que el personal esté en todos los casos
        debidamente calificado. Avalith hará todos los esfuerzos razonables para
        proporcionar los Servicios a través del mismo personal durante la
        duración de un SOW, siempre que Avalith tenga derecho a reemplazar a
        dicho personal con personal de calificación y experiencia equivalentes
        con un aviso de no menos de 5 días hábiles al Socio. Los ingenieros
        pueden incluir empleados, contratistas independientes, subcontratistas o
        agentes de Avalith.
      </p>

      <h4 className="pb-4 font-bold text-xl">5. PROPIEDAD INTELECTUAL</h4>

      <p className="pb-4">
        (a) Cesión. Todos los derechos de autor de cualquier entregable
        entregados de conformidad con una SOW ("Entrega") o que surjan de los
        Servicios prestados por los Ingenieros pasarán a ser propiedad del Socio
        tras el pago total de todos los montos adeudados. Dependiendo de dicho
        pago, Avalith cede por la presente al Socio, o su designado, todos los
        derechos, títulos e intereses de Avalith sobre todos y cada uno de esos
        derechos de autor en todo el mundo. Avalith conservará cualquiera de sus
        derechos de propiedad intelectual preexistentes y cualquier derecho
        residual siempre que, en la medida en que dichos derechos de propiedad
        intelectual estén incorporados en los Entregables, Avalith otorga al
        Socio una licencia mundial no exclusiva para usar dicha propiedad
        intelectual derechos en la medida necesaria para el uso de los
        Entregables.
      </p>

      <p className="pb-4">
        (b) Materiales de socios. El socio conservará la propiedad de todo el
        contenido y los materiales proporcionados a Avalith a continuación. El
        socio asume la responsabilidad total de cualquier contenido (incluidos,
        entre otros, gráficos, audio, texto de copia, video e imágenes)
        proporcionado a Avalith para su uso en su proyecto. El socio declara y
        garantiza que tiene todos los derechos para explotar todo el contenido y
        los materiales proporcionados a Avalith.
      </p>

      <h4 className="pb-4 font-bold text-xl">6. IMPUESTOS</h4>

      <p className="pb-4">
        El socio no es responsable de los impuestos relacionados con los
        ingresos netos de Avalith. El Socio será responsable de los impuestos
        sobre las ventas, el uso o el valor agregado que adeude debido a este
        Acuerdo que la ley exige que Avalith le cobre al Socio. En el caso de
        que Avalith deba pagar en cualquier momento cualquier impuesto por el
        que sea responsable el Socio, el Socio reembolsará sin demora a Avalith
        dichos pagos, sujeto a la provisión al Socio de la documentación de
        respaldo que acredite dichos pagos.
      </p>

      <h4 className="pb-4 font-bold text-xl">7. GARANTÍAS</h4>

      <p className="pb-4">
        (a) Cada Parte garantiza y declara que tiene plena autoridad para
        celebrar este Acuerdo, para consumar las transacciones contempladas en
        el presente, y que este Acuerdo no está en conflicto con ningún otro
        acuerdo en el que dicha Parte sea parte o por el cual sea parte. Unido.
      </p>

      <p className="pb-4">(b) Avalith garantiza y declara además que:</p>

      <p className="pb-4 pl-12">
        (i) cada uno de sus Ingenieros asignados para realizar cualquier parte
        de las provisiones de los Servicios bajo un SOW deberá tener la
        habilidad, entrenamiento y antecedentes adecuados para su nivel de
        competencia como se especifica en el SOW para poder desempeñarse en de
        manera competente y profesional;
      </p>

      <p className="pb-4 pl-12">
        (ii) en el momento de la cesión, el Socio recibirá un título válido y
        comercial de todos los derechos de autor en los materiales originales
        incluidos en los Entregables o desarrollados bajo este Acuerdo, a menos
        que se especifique lo contrario en un SOW, libre y libre de todos los
        gravámenes, reclamaciones, gravámenes e intereses de seguridad de
        cualquier tipo de un tercero;
      </p>

      <p className="pb-4 pl-12">
        (iii) a menos que se establezca expresamente en un SOW, todos los
        Entregables y Servicios proporcionados por Avalith al Socio por su
        personal se entregan o se proporcionan "tal cual" y "donde está" y
        pueden o no estar libres de errores; y
      </p>

      <p className="pb-4 pl-12">
        (iv) AVALITH NO HACE OTRAS DECLARACIONES O GARANTÍAS DE NINGÚN TIPO,
        EXCEPTO LO QUE SE INDICA EXPRESAMENTE AQUÍ. ESPECÍFICAMENTE, AVALITH
        RENUNCIA A TODAS LAS GARANTÍAS, REPRESENTACIONES Y GARANTÍAS (YA SEAN
        EXPRESAS O IMPLÍCITAS, ORALES O POR ESCRITO, INCLUYENDO LAS GARANTÍAS
        IMPLÍCITAS DE COMERCIABILIDAD, IDONEIDAD PARA UN PROPÓSITO PARTICULAR,
        QUE NO SE TRADUZCA O QUE NO SE TRADUZCA) RELACIONADOS DE ALGUNA MANERA
        CON LOS SERVICIOS, ESTE ACUERDO O UNA SOW
      </p>

      <h4 className="pb-4 font-bold text-xl">
        8. LIMITACIÓN DE RESPONSABILIDAD; EXCLUSIÓN DE CIERTOS DAÑOS
      </h4>

      <p className="pb-4">
        Excepto por las responsabilidades resultantes de la mala conducta
        intencional y / o intencional real de cualquiera de las Partes, la
        responsabilidad de cada Parte en virtud del presente no excederá las
        tarifas pagadas o pagaderas por el Socio dentro del período de un año
        inmediatamente anterior a la fecha en que ocurrió el presunto acto
        ilícito. NI EL SOCIO NI AVALITH SERÁN RESPONSABLES ANTE OTRO DE NINGÚN
        DAÑO, PÉRDIDA, COSTOS O GASTOS INDIRECTOS, PÉRDIDAS, COSTOS O GASTOS
        ESPECIALES, CONSECUENTES, INCIDENTALES, PUNITIVOS O INDIRECTOS DE NINGÚN
        TIPO O GANANCIAS PERDIDAS O IMPUESTAS QUE SURJAN DE ESTE ACUERDO O DE
        CUALQUIER ACUERDO LA TERMINACIÓN, CUALQUIER CAUSADA Y YA SEA BASADA EN
        CONTRATO, AGRAVIO (INCLUYENDO NEGLIGENCIA), RESPONSABILIDAD DE PRODUCTOS
        O CUALQUIER OTRA TEORÍA DE RESPONSABILIDAD INDEPENDIENTEMENTE DE SI
        DICHA PARTE HA SIDO ADVERTIDA DE LA POSIBILIDAD DE DICHOS DAÑOS,
        PÉRDIDAS, COSTOS.
      </p>

      <h4 className="pb-4 font-bold text-xl">9. INDEMNIZACIÓN</h4>

      <p className="pb-4">
        Avalith acepta indemnizar al Socio y a los directores, funcionarios,
        afiliados, empleados, personal y agentes del Socio por todas y cada una
        de las pérdidas, daños, sanciones, acuerdos, costos y gastos (incluidos
        los honorarios razonables de abogados) (colectivamente, "Pérdidas"), y
        para defender al Socio en cualquier demanda, reclamo o procedimiento,
        iniciado por un tercero o agencia gubernamental, que surja del
        incumplimiento de Avalith de cualquier disposición de este Acuerdo o de
        cualquier SOW aplicable y / o la violación de Avalith de cualquier ley o
        reglamento aplicable. El Socio se compromete a indemnizar a Avalith y a
        los directores, funcionarios, afiliados, empleados, personal y agentes
        de Avalith contra todas y cada una de las Pérdidas, y a defender a
        Avalith en cualquier demanda, reclamo o procedimiento presentado por
        cualquier tercero o agencia gubernamental, que surja de las
        incumplimiento de cualquier disposición de este Acuerdo o cualquier SOW
        aplicable, y / o la violación del Socio de cualquier ley o reglamento
        aplicable. En consideración de estas obligaciones de indemnización, cada
        Parte debe proporcionar a la Parte indemnizadora un aviso inmediato de
        la afirmación de cualquier reclamación y permitir que la Parte
        indemnizadora asuma el control total de la defensa y / o resolución de
        la misma. Sin perjuicio de lo anterior, una Parte indemnizadora no
        celebrará un acuerdo que afecte los derechos de la Parte indemnizada sin
        el consentimiento previo por escrito de dicha Parte indemnizada.
      </p>

      <h4 className="pb-4 font-bold text-xl">10. CONFIDENCIALIDAD</h4>

      <p className="pb-4">
        Salvo que se disponga de forma expresa e inequívoca en este documento o
        en cualquier SOW acordado, la Parte receptora mantendrá la
        confidencialidad y no revelará ninguna Información Confidencial de la
        Parte reveladora y vinculará de manera similar a su personal. Cada Parte
        reconoce y acepta que cualquier Información Confidencial recibida u
        obtenida de la otra Parte será propiedad única y exclusiva de la otra
        Parte y no podrá ser utilizada, difundida o divulgada excepto cuando sea
        necesario para cumplir con las obligaciones requeridas bajo este
        Acuerdo. cualquier SOW acordado o según lo requiera la ley. Si la ley
        exige la divulgación, la Parte obligada a divulgar Información
        Confidencial deberá cooperar razonablemente con la otra Parte (a
        solicitud y cargo de la otra Parte) para que la otra Parte pueda
        preservar la confidencialidad de la Información Confidencial en la
        medida de lo razonablemente posible. No obstante lo anterior, la
        Información Confidencial no incluye información que: (a) es de dominio
        público antes de la divulgación o se convierte en parte del dominio
        público sin un acto ilícito de la Parte receptora; (b) estaba en
        posesión legal de la Parte receptora antes de la divulgación; (c) fue
        desarrollado independientemente por la Parte receptora fuera del alcance
        de este Acuerdo; o (d) fue revelada a la Parte receptora por un tercero
        que estaba en posesión legal de la información. La Información
        Confidencial no incluye información que: (a) es de dominio público antes
        de la divulgación o pasa a formar parte del dominio público sin un acto
        ilícito de la Parte receptora; (b) estaba en posesión legal de la Parte
        receptora antes de la divulgación; (c) fue desarrollado
        independientemente por la Parte receptora fuera del alcance de este
        Acuerdo; o (d) fue revelada a la Parte receptora por un tercero que
        estaba en posesión legal de la información. La Información Confidencial
        no incluye información que: (a) es de dominio público antes de la
        divulgación o pasa a formar parte del dominio público sin un acto
        ilícito de la Parte receptora; (b) estaba en posesión legal de la Parte
        receptora antes de la divulgación; (c) fue desarrollado
        independientemente por la Parte receptora fuera del alcance de este
        Acuerdo; o (d) fue revelada a la Parte receptora por un tercero que
        estaba en posesión legal de la información.
      </p>

      <h4 className="pb-4 font-bold text-xl">11. SIN EXCLUSIVIDAD</h4>

      <p className="pb-4">
        Los Servicios de Avalith, incluidos, entre otros, los descritos en los
        términos de este Acuerdo, no son ni se considerarán exclusivos del Socio
        ni de sus afiliados. Avalith es y seguirá siendo libre de prestar
        servicios similares a otras entidades y de participar en todas las
        actividades que Avalith considere apropiadas, siempre que al hacerlo,
        Avalith no incumpla ningún convenio u obligación expresamente
        establecida en este Acuerdo. Avalith no tendrá ningún deber u obligación
        de revelar al Socio cualquier información confidencial o de propiedad
        que Avalith pueda adquirir sobre el negocio, las operaciones o las
        actividades de cualquier otra persona o entidad, incluso si dicha
        información pudiera considerarse material y relevante para el Socio.
      </p>

      <h4 className="pb-4 font-bold text-xl">12. PUBLICIDAD, REFERENCIAS</h4>

      <p className="pb-4">
        Cada uno de Avalith y el Socio puede usar el nombre y el logotipo de la
        otra Parte en comunicados de mercadeo, publicidad y / o publicidad
        comercialmente razonables, y describir el trabajo completado bajo este
        Acuerdo y cualquier SOW relacionado en forma resumida y general, sin
        revelar ninguno de los otros Información confidencial de las partes
        siempre que la relación entre las partes se describa con precisión, sin
        obtener la aprobación adicional por escrito de la otra parte.
      </p>

      <h4 className="pb-4 font-bold text-xl">13. NO SOLICITADO</h4>

      <p className="pb-4">
        El socio reconoce que Avalith invierte importantes recursos en la
        contratación de sus ingenieros. Sujeto a la Sección 14, durante el
        Período de vigencia de la MSA y durante un año a partir de entonces, el
        Socio no alentará o solicitará, directa o indirectamente, la
        contratación, contratación o contratación de servicios (excluyendo los
        Servicios de Avalith a continuación), alentará o inducirá a rescindir
        una relación con Avalith, cualquier Ingeniero al que se presente un
        Socio a través de Avalith en relación con este Acuerdo.
      </p>

      <h4 className="pb-4 font-bold text-xl">14. TARIFA DE CONTRATACIÓN</h4>

      <p className="pb-4">
        Sujeto al consentimiento expreso por escrito de Avalith, que puede ser
        retenido o condicionado a la entera discreción de Avalith, en el caso de
        que el Socio contrate o contrate (excepto a través de Avalith) a
        cualquier Ingeniero dentro de un año después de la finalización del
        Plazo de MSA, el Socio deberá pagar una tarifa de contratación ( la
        “Tarifa de contratación”) de (i) $ 30,000 o (ii) si el Socio agrega un
        nuevo Ingeniero por un contrato mínimo de un año a la tarifa publicada
        en ese momento, $ 10,000. Los gastos de Avalith en los que incurrió para
        reemplazar a un Ingeniero no se pueden determinar con certeza, por lo
        que las Partes acuerdan que la Tarifa de Contratación es una estimación
        razonable de los gastos de Avalith para obtener, encontrar, reclutar,
        seleccionar, contratar y reemplazar a cada Ingeniero y operar su negocio
        con respecto a tal ingeniero.
      </p>

      <h4 className="pb-4 font-bold text-xl">15. NO INTERFERENCIA</h4>

      <p className="pb-4">
        Durante el Período de vigencia de la MSA y durante un año a partir de
        entonces, el Socio no inducirá ni intentará inducir a ningún cliente,
        vendedor o proveedor de Avalith a que cese o reduzca su nivel de
        negocios con Avalith.
      </p>

      <h4 className="pb-4 font-bold text-xl">16. RELACIÓN</h4>

      <p className="pb-4">
        Ni la realización de este Acuerdo ni el cumplimiento de cualquier
        disposición a continuación se interpretará como que constituye a una de
        las Partes o su personal como agente, empleado o representante legal de
        la otra para cualquier propósito, ni se considerará que este Acuerdo
        establece una empresa conjunta o asociación entre Avalith y el Socio o
        para crear cualquier relación entre las partes del presente que no sea
        la de partes contratantes independientes.
      </p>

      <h4 className="pb-4 font-bold text-xl">17. DEBERES LIMITADOS</h4>

      <p className="pb-4">
        En la medida en que Avalith, a través de la prestación de Servicios al
        Socio, esté obligada a tener un deber fiduciario u otro deber similar
        con el Socio más allá de los convenios y acuerdos específicos
        establecidos en este Acuerdo, dichos deberes fiduciarios u otros deberes
        similares deben establecerse expresamente y mencionarse en la SOW
        aplicable. En ausencia de un lenguaje expreso que cree una relación
        fiduciaria, nada en este Acuerdo (o que surja de la entrega o recepción
        de bienes o servicios) operará o se interpretará que opere para crear
        obligaciones fiduciarias adeudadas por Avalith.
      </p>

      <h4 className="pb-4 font-bold text-xl">18. RETRASO EXCUSIBLE</h4>

      <p className="pb-4">
        Ninguna de las Partes será responsable por el incumplimiento de
        cualquier obligación (que no sean las obligaciones de pago) debido a
        causas fuera del control razonable de dicha Parte, incluidos los
        elementos, casos fortuitos, disputas laborales, actos del enemigo
        público y / o terrorismo, actos de autoridad civil o militar, incendios,
        inundaciones, epidemias, restricciones de cuarentena, fallas o
        comportamiento errático de los sistemas de telecomunicaciones o de
        energía, sabotajes, hostilidades armadas y disturbios. Sin perjuicio de
        lo anterior, en todo caso la demora o incumplimiento deberá estar fuera
        del control y sin culpa o negligencia de la Parte que reclama la demora
        excusable. Los tiempos de ejecución bajo este Acuerdo se considerarán
        extendidos por un período de tiempo equivalente al tiempo perdido debido
        a cualquier demora que sea excusable en virtud del presente;
        disponiéndose, sin embargo, que, si tal demora.
      </p>

      <h4 className="pb-4 font-bold text-xl">
        19. ACUERDO DE TRATAMIENTO DE DATOS
      </h4>

      <p className="pb-4">
        (a) GDPR. Si (i) Directiva 94/46 / CE del Parlamento Europeo y del
        Consejo sobre la protección de las personas con respecto al
        procesamiento de Datos Personales y sobre la libre circulación de dichos
        datos ("Directiva"), o (ii) El Reglamento 2016/679 del Parlamento
        Europeo y del Consejo sobre la protección de las personas físicas con
        respecto al procesamiento de Datos Personales y sobre la libre
        circulación de dichos datos (Reglamento General de Protección de Datos)
        ("GDPR"), son aplicables a Servicios proporcionados por Avalith, luego
        los términos que se encuentran en https://andela.com/dpa se incorporarán
        aquí, y el Socio se considerará el "Controlador" y Avalith se
        considerará el "Procesador".
      </p>

      <p className="pb-4">
        (b) CCPA. En la medida en que la Ley de Privacidad del Consumidor de
        California sea aplicable a los Servicios proporcionados por Avalith,
        Avalith acepta que no recopilará, retendrá, procesará, usará ni
        divulgará ninguna información personal recopilada en nombre del Socio
        para ningún propósito (incluido cualquier propósito comercial) que no
        sea el propósito específico de realizar los Servicios especificados en
        este Acuerdo.
      </p>

      <h4 className="pb-4 font-bold text-xl">20. ACUERDO COMPLETO</h4>

      <p className="pb-4">
        Este Acuerdo contiene el acuerdo completo de las Partes y reemplaza
        todos los acuerdos anteriores escritos o verbales, si los hubiere y de
        cualquier tipo o tipo, incluyendo, pero no limitado a, todas las
        discusiones previas entre las Partes con respecto al tema del presente.
        Los términos y condiciones de todos y cada uno de los anexos, anexos,
        anexos y SOW acordados contemporáneos o futuros se incorporan aquí como
        referencia y constituirán partes indivisibles de este Acuerdo como si se
        hubieran establecido en su totalidad hoy.
      </p>

      <h4 className="pb-4 font-bold text-xl">21. DIVISIBILIDAD</h4>

      <p className="pb-4">
        Si una o más de las disposiciones (o partes de las mismas) de este
        Acuerdo por cualquier motivo se considerara inválida, ilegal o
        inaplicable en cualquier aspecto por una determinación final de un
        tribunal de jurisdicción competente, dicha invalidez, ilegalidad o la
        inaplicabilidad no afectará ninguna otra disposición (o parte de las
        disposiciones) de este Acuerdo, y la disposición inválida, ilegal o
        inaplicable se considerará reemplazada por una disposición que sea
        válida, legal y ejecutable y que se acerque más a expresar la intención
        de las Partes.
      </p>

      <h4 className="pb-4 font-bold text-xl">22. ENMIENDAS, MODIFICACIONES</h4>

      <p className="pb-4">
        Ninguna modificación, enmienda, complemento o renuncia a este Acuerdo o
        cualquiera de sus disposiciones será vinculante para las Partes del
        mismo a menos que se haga por escrito y esté debidamente firmado por
        ambas Partes. La falla o demora de cualquiera de las Partes de este
        Acuerdo para hacer cumplir en cualquier momento cualquiera de las
        disposiciones de este Acuerdo, o para ejercer cualquier opción que se
        proporciona en el presente, o para requerir en cualquier momento el
        cumplimiento de cualquiera de las disposiciones del presente, nunca será
        se interpretará como una renuncia a tal disposición de este Acuerdo y no
        excusará el desempeño de la otra Parte, ni afectará ningún derecho en un
        momento posterior para hacer cumplir la disposición.
      </p>

      <h4 className="pb-4 font-bold text-xl">23. CESIÓN</h4>

      <p className="pb-4">
        Ninguna de las Partes podrá ceder este Acuerdo, en su totalidad o en
        parte, sin el consentimiento previo por escrito de la otra Parte (que
        puede ser retenido o condicionado), excepto a cualquier filial, o en
        relación con cualquier fusión, consolidación, reorganización, venta de
        todo o sustancialmente todos sus activos o transacciones similares,
        siempre que el cesionario acepte por escrito estar sujeto a todos los
        términos y condiciones de este Acuerdo y todos los SOW. Sujeto a lo
        anterior, este Acuerdo será vinculante y ejecutable por las Partes y sus
        respectivos sucesores y cesionarios autorizados. El consentimiento de
        cualquiera de las Partes para la cesión en una instancia no constituirá
        el consentimiento de dicha Parte para cualquier otra cesión.
      </p>

      <h4 className="pb-4 font-bold text-xl">
        24. LEY APLICABLE Y JURISDICCIÓN, HONORARIOS, COSTOS
      </h4>

      <p className="pb-4">
        Este Acuerdo se regirá e interpretará de acuerdo con las leyes del
        Estado de Nueva York sin referencia a las disposiciones sobre conflicto
        de leyes. Cualquier disputa, reclamación o controversia que surja de o
        esté relacionada con este Acuerdo se resolverá en los tribunales
        federales o estatales con sede en el condado de Nueva York, Nueva York.
        En cualquier procedimiento relacionado con una disputa que surja de o se
        relacione con este Acuerdo, la Parte prevaleciente tendrá derecho a una
        adjudicación de honorarios y costos legales razonables (por ejemplo, se
        adopta la “Regla inglesa”).
      </p>

      <h4 className="pb-4 font-bold text-xl">25. AVISOS</h4>

      <p className="pb-4">
        Todas las notificaciones y otras comunicaciones requeridas o permitidas
        en virtud de este Acuerdo se considerarán debidamente entregadas y
        realizadas en el momento de la recepción real si se hacen por escrito y
        si se entregan (i) mediante entrega personal a la Parte destinada (que
        incluirá la entrega por FedEx o servicio similar, sin requisito de firma
        en el momento de la entrega), (ii) por franqueo prepago, correo
        certificado o registrado, con acuse de recibo solicitado, en el correo
        de los Estados Unidos, o (iii) por correo electrónico a la dirección
        pertinente para dicha Parte, con confirmación de regreso de entrega, y
        en cada caso con la dirección registrada en ese momento, o cualquier
        otra dirección que pueda ser designada en lo sucesivo por dicha Parte.
      </p>

      <h4 className="pb-4 font-bold text-xl">26. CONSTRUCCIÓN</h4>

      <p className="pb-4">
        Cada Parte y sus abogados han participado plenamente en la revisión y
        revisión de este Acuerdo. Cualquier regla de construcción que sugiera o
        requiera ambigüedades se resuelva en contra de la Parte redactora no se
        aplicará en la interpretación de este Acuerdo.
      </p>

      <h4 className="pb-4 font-bold text-xl">27. CONTRAPIEZAS</h4>
      <p className="pb-4">
        Este Acuerdo puede ser ejecutado mediante firma electrónica, y en
        contrapartes, cada una de las cuales se considerará original, pero todas
        esas contrapartes constituirán un solo instrumento.
      </p>
    </section>
  )
}

export default Contracts
